import { useState } from 'react';
import { IonIcon, IonItem, IonLabel, IonSpinner } from '@ionic/react';
import { exitOutline } from 'ionicons/icons';
import { LeaveLeagueAlert } from './LeaveLeagueAlert';
import { useLeaveLeague } from '../hooks/useLeaveLeague';

interface LeaveLeagueItemProps {
  leagueId: string;
}

// Item of the league settings list (rendered inside the page's IonList),
// available to every member (not only admins).
export const LeaveLeagueItem = ({ leagueId }: LeaveLeagueItemProps) => {
  const [showAlert, setShowAlert] = useState(false);
  const { leaveLeague, leaving } = useLeaveLeague(leagueId);

  return (
    <>
      <IonItem button disabled={leaving} onClick={() => setShowAlert(true)}>
        <IonIcon icon={exitOutline} slot="start" className="mr-3" color="danger" />
        <IonLabel color="danger">Abandonar liga</IonLabel>
        {leaving && <IonSpinner name="crescent" slot="end" />}
      </IonItem>

      <LeaveLeagueAlert
        isOpen={showAlert}
        onDismiss={() => setShowAlert(false)}
        onConfirm={leaveLeague}
      />
    </>
  );
};
